export const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';

// Shared across List.js/Form.js so the URL only needs to change in one place.
// AppContainer.js registers these same paths as <Route> definitions - kept as literals
// there to match that file's own convention (every other module's routes are inline too).
export const ROUTES = {
    LIST: '/ar/collections/follow-up',
    EDIT: '/ar/collections/edit-follow-up',
    ADD: '/ar/collections/add-follow-up',
};

// IDRELATIONSHIPLINKS types behind "the customer's contacts", from uARM0009.dfm's
// qryCustomerContact BaseWhere: IDMASTERTYPE = '01' (Customer) AND IDMEMBERTYPE = '22'
// (Contact). Shared by ContactTab (the Contact tab grid) and DetailsTab (the Contact With
// lookup) so the codes are declared once.
export const CUSTOMER_ID_TYPE = '01';
export const CONTACT_MEMBER_TYPE = '22';

// Page-size choices shared by every grid on this screen.
export const GRID_PAGE_SIZES = [10, 20, 100, 500, 1000, "all"];

// DevExtreme numeric format for every money column across this screen's grids.
export const CURRENCY_FORMAT = "$#,##0.00";

// Wire format for the detail grid's date/time columns.
export const DATETIME_SERIALIZATION_FORMAT = "yyyy-MM-ddTHH:mm:ss";

// GridLayoutManager's built-in layout name, used as the initial currentLayout state
// before the user picks a saved layout.
export const DEFAULT_LAYOUT_NAME = "Default";

// Grid-layout storage keys. Collected here so they stay unique and auditable instead
// of being scattered GUID literals across the component files.
export const GRID_KEYS = {
    FollowUpList: '6B8D3F1A-2C47-4E9B-A1D6-3F7C9E2B5A48',
    FollowUpDetail: '9F4A2C7E-6B18-4D93-A5C0-1E7B3D8F2A64',
    Contact: '2B6F8A1C-9D34-4E7B-8A5C-1F3E6B9D2C47',
};

// Dynamic-form layout identities (id + name pairs used by FormField).
export const FORM_LAYOUTS = {
    Search: { id: '4C9E7B2A-1D53-4F86-A0C7-2E6D9B3F5A17', name: 'ARCollectionCreditSearchForm' },
    Primary: { id: '7D2A9E4C-3B58-4A17-9E0C-5F1D8A6B2C93', name: 'ARCollectionCreditPrimaryForm' },
};
